export enum ECurrencyCode {
  CZK = 'CZK',
  EUR = 'EUR',
  // todo - there should probably also be us$ as some instruments already use this currency
}

export enum EInvestmentFrequency {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}

export type EsgTypes = 'AAA' | 'AA' | 'A' | 'BBB' | 'BB' | 'B' | 'CCC';
export type IncomeTypes = 'DISTRIBUTING' | 'ACCUMULATING';
export type InstrumentTypes = 'ETF' | 'OPF';
export type InstrumentTargets = 'REGIONAL' | 'THEMATIC' | 'SECTORAL';
export type UserTypes = 'client';

export const investmentFrequencyMap = new Map<EInvestmentFrequency, number>([
  [EInvestmentFrequency.WEEKLY, 1],
  [EInvestmentFrequency.MONTHLY, 4],
  [EInvestmentFrequency.QUARTERLY, 12]
]);

export const investmentFrequencyMapByNumber = new Map<number, EInvestmentFrequency>([
  [1, EInvestmentFrequency.WEEKLY],
  [4, EInvestmentFrequency.MONTHLY],
  [12, EInvestmentFrequency.QUARTERLY]
]);

export enum EManagementType {
  PORTFOLIO_MANAGEMENT = 'PORTFOLIO_MANAGEMENT',
  EXECUTION_ONLY = 'EXECUTION_ONLY',
}

export enum ELanguage {
  'cs-CZ' = 'cs-CZ',
  'en-GB' = 'en-GB',
}

export enum EInstrumentCategory {
  EQUITY = 'EQUITY',
  BOND = 'BOND',
  ALTERNATIVE = 'ALTERNATIVE',
  COMODITY = 'COMODITY',
  MONEY = 'MONEY',
  CASH = 'CASH',
  REAL_ESTATE = 'REAL_ESTATE',
  LEVERAGED = 'LEVERAGED',
  CRYPTOCURRENCY = 'CRYPTOCURRENCY',
  MULTI_ASSET = 'MULTI_ASSET',
}

export enum EInstrumentTarget {
  THEMATIC = 'THEMATIC',
  SECTORAL = 'SECTORAL',
  REGIONAL = 'REGIONAL',
}

export enum EModelStrategyType {
  THEMATIC_STRATEGY = 'THEMATIC_STRATEGY',
  MODEL_PORTFOLIO = 'MODEL_PORTFOLIO',
  OKS = 'OKS',
}

import { ELoadingEntity, IErrorProperty } from './generic-store.model';
import { EInvestmentDetailMenuAction, ERegularWithdrawalFrequency } from './products.model';

export interface ILoadingErrorState {
  loadingProps: ELoadingEntity[];
  errorProps: Partial<Record<ELoadingEntity, IErrorProperty>>;
}

export const baseState: ILoadingErrorState = {
  loadingProps: [],
  errorProps: {}
}

export interface IPageRequest {
  [index: string]: number | unknown,
  page?: number; // from 0
  size?: number;
}

export enum EFaqPageCode {
  DASHBOARD = 'DASHBOARD',
  LOGIN_PAGE = 'LOGIN_PAGE',
  MONEY_AND_TRANSACTIONS = 'MONEY_AND_TRANSACTIONS',
  TOP_5 = 'TOP_5',
  LANDING_PAGE_THEMATIC_STRATEGY = 'LANDING_PAGE_MODEL_STRATEGY',
  LANDING_PAGE_CUSTOM_STRATEGY = 'LANDING_PAGE_STRATEGY',
}
export enum ESortDirections {
  HIGH_RISK = 'HIGH_RISK',
  LOW_RISK = 'LOW_RISK'
};

export enum ECharTypes {
  'INSTRUMENTS' = 1,
  'REGION' = 2,
  'HISTORY' = 3,
}

export interface IErrorOptionsInput {
  acceptedErrorCodes?: string[],
  includedErrorMessage?: string,
  excludeStatusCode?: true,
}

export interface IHotlineAvailability {
    openNow: boolean;
    openDateTime: string;
    closeDateTime: string;
}

export interface ILabelValuePair {
  label: string;
  value: number;
}

export interface IKeyValueStrPair {
  key: string,
  value: string,
};

export interface IPresignedUrl {
  exists?: boolean;
  url: string;
}

export interface IImageUploadMaxSize {
  maxSize: number; // in bytes
}

export enum EPhotoContentType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
}

export interface IImageUploadProps {
  contentLength: number;
  contentType: EPhotoContentType;
  fileName?: string;
}

export interface IUploadImageOutput {
  image: Blob;
  contentType: EPhotoContentType;
  fileName?: string;
}

export interface IDropdownMenuItem {
  label: string;
  icon: string;
  key: EInvestmentDetailMenuAction;
  color?: 'danger';
  disabled?: boolean;
  disabledTooltip?: string | null;
}

export enum EInvestmentType {
  MODEL_PORTFOLIO = 1, THEMATIC_STRATEGY, CUSTOM_STRATEGY
}

export const regularWithdrawalFrequencyMap = new Map<ERegularWithdrawalFrequency, string>([
  [ERegularWithdrawalFrequency.MONTHLY, 'moneyAndTransactions.regularWithdrawalFrequency.MONTHLY'],
  [ERegularWithdrawalFrequency.QUARTERLY, 'moneyAndTransactions.regularWithdrawalFrequency.QUARTERLY']
]);